import type { Phase, RoleId } from '@noxbury/engine';

export const ROLE_NAMES: Record<RoleId, string> = {
  VILLAGER: 'Dorfbewohner',
  VAMPIRE: 'Vampir',
  SEER: 'Seherin',
  CURSED: 'Verfluchter',
  WITCH: 'Hexe',
  PRIEST: 'Priester',
  VAMPIRE_HUNTRESS: 'Vampirjägerin',
  FOOL: 'Narr',
  DEMON: 'Dämon',
};

export const PHASE_NAMES: Record<Phase, string> = {
  LOBBY: 'Lobby',
  ROLE_SETUP: 'Rollen festlegen',
  MAYOR_ELECTION: 'Bürgermeisterwahl',
  GAME_START: 'Bereit für die erste Nacht',
  NIGHT_START: 'Die Nacht beginnt',
  DRUNK_REVEAL: 'Der Trunkenbold erwacht',
  LOVERS_PHASE: 'Die Geliebten',
  VAMPIRE_PHASE: 'Die Vampire',
  SEER_PHASE: 'Die Seherin',
  WITCH_PHASE: 'Die Hexe',
  PRIEST_PHASE: 'Der Priester',
  DEMON_PHASE: 'Der Dämon',
  GHOST_PHASE: 'Der Geist',
  NIGHT_RESOLUTION: 'Die Nacht wird ausgewertet',
  MORNING_REVEAL: 'Der Morgen',
  DEATH_RESOLUTION: 'Letzte Verfügungen',
  DISCUSSION: 'Beratung',
  DAY_VOTE: 'Abstimmung',
  VOTE_REVEAL: 'Stimmen aufgedeckt',
  DAY_VOTE_RESOLUTION: 'Urteil',
  MAYOR_TIEBREAK: 'Der Bürgermeister entscheidet',
  GAME_END: 'Ende der Partie',
};

export const WIN_NAMES: Record<string, string> = {
  DEMON: 'Der Dämon',
  VILLAGE: 'Das Dorf',
  VAMPIRE: 'Die Vampire',
  LOVERS: 'Die Geliebten',
  FOOL: 'Der Narr',
};

/** Ganze Sätze für das Overlay, damit dort nicht bloß „Ende“ steht. */
export const WIN_SENTENCES: Record<string, string> = {
  DEMON: 'Der Dämon gewinnt',
  VILLAGE: 'Das Dorf gewinnt',
  VAMPIRE: 'Die Vampire gewinnen',
  LOVERS: 'Die Geliebten gewinnen',
  FOOL: 'Der Narr gewinnt',
};

export function winSentence(winners: readonly string[]): string {
  if (winners.length === 0) return 'Die Partie ist beendet';
  if (winners.length === 1) return WIN_SENTENCES[winners[0]!] ?? `${winners[0]} gewinnt`;
  // Mehrere Sieger: gemeinsame Nennung, Verb im Plural.
  const namen = winners.map((w) => WIN_NAMES[w] ?? w);
  return `${namen.slice(0, -1).join(', ')} und ${namen[namen.length - 1]} gewinnen`;
}

export function roleName(role: string | null | undefined): string {
  if (!role) return 'Noch keine Rolle';
  if (role === 'DRUNK') return 'Trunkenbold';
  return ROLE_NAMES[role as RoleId] ?? role;
}

export function phaseName(phase: string): string {
  return PHASE_NAMES[phase as Phase] ?? phase;
}

export function timeOfDay(at: string): string {
  return new Date(at).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
